import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

/**
 * 社区许愿墙（任务墙）提现台账 物业Web端 数据封装API
 * 后端服务编码统一走 /app/taskWall.*Withdraw
 * 业务：接单人（业主端）自助发起提现，平台端财务在此台账审核 -> 线下打款 -> 标记已付款
 * add by java110 team
 */

// 提现状态机（与后端 TaskWallWithdrawDto 保持一致）
export const WITHDRAW_STATE = {
  WAIT_AUDIT: '1000', // 待审核（钱包已冻结扣减）
  AUDIT_PASS: '2000', // 审核通过/待付款
  PAID: '3000', // 已付款（线下打款完成）
  REJECT: '4000' // 已拒绝（钱包已退回）
}

// 提现状态名称映射
export const WITHDRAW_STATE_NAME = {
  '1000': '待审核',
  '2000': '待付款',
  '3000': '已付款',
  '4000': '已拒绝'
}

// 收款方式名称映射
export const RECEIVE_TYPE_NAME = {
  wechat: '微信',
  alipay: '支付宝',
  bank: '银行卡'
}

// 获取提现状态名称
export function getWithdrawStateName(state) {
  return WITHDRAW_STATE_NAME[state] || '未知'
}

// 获取收款方式名称
export function getReceiveTypeName(receiveType) {
  return RECEIVE_TYPE_NAME[receiveType] || receiveType || '-'
}

// 查询提现台账列表（平台端）
export function listWithdraw(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/taskWall.listWithdraw',
      method: 'get',
      params: {
        ...params,
        communityId: params.communityId || getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 审核提现（pass 通过 / reject 拒绝）
export function auditWithdraw(data) {
  return postWithdraw('/taskWall.auditWithdraw', data)
}

// 付款确认（线下打款完成后标记已付款）
export function payWithdraw(data) {
  return postWithdraw('/taskWall.payWithdraw', data)
}

// 统一的操作类 POST 请求封装
function postWithdraw(url, data) {
  return new Promise((resolve, reject) => {
    request({
      url,
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
